import { Component, EventEmitter, Input, NgZone, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { RoleService } from "../../services/roles/role.service";
import { CommonService } from "../../services/common.service";
import { LocalServiceService } from "../../services/local-service.service";

declare const google: any;

@Component({
    selector: 'app-google-map',
    templateUrl: './google-map.component.html',
    styleUrls: ['./google-map.component.scss']
})
export class GoogleMapComponent implements OnInit {
    @Input() params: {
        postalCode: any,
        latLong: any
    } | null = null;
    @Input() readonly: boolean | null = true
    @Output() changeRegion = new EventEmitter<any>();
    @Input() mapName: string | null = 'google-map-body'

    title = 'My Angular Google Maps App';
    lat: number = 1.3521;
    lng: number = 103.8198;
    map: any;
    geocoder: any;
    marker: any;
    postalCode: string = '';
    address: string = '';
    @Input() isCommunity: boolean | null = false;

    constructor(
        private ngZone: NgZone,
        public roleService: RoleService,
        private commonService: CommonService,
        private local: LocalServiceService
    ) { }

    ngOnInit(): void {
    }

    ngAfterViewInit() {

        this.initMap();
        if (this.params.postalCode != '') this.geocodePostalCode()
    }

    initMap(): void {
        this.map = new google.maps.Map(document.getElementById(this.mapName), {
            center: { lat: this.lat, lng: this.lng },
            zoom: 12,
            restriction: {
                latLngBounds: {
                    north: 1.47,
                    south: 1.22,
                    east: 104.05,
                    west: 103.62
                },
                strictBounds: true
            }
        });

        this.geocoder = new google.maps.Geocoder();

        this.map.addListener('click', (event: any) => {
            this.placeMarkerAndPanTo(event.latLng);
        });
    }

    placeMarkerAndPanTo(latLng: any): void {
        if (this.marker) {
            this.marker.setPosition(latLng);
        } else {
            this.marker = new google.maps.Marker({
                position: latLng,
                map: this.map
            });
        }
        this.map.panTo(latLng);
        this.geocodeLatLng(latLng);
    }

    async geocodePostalCode(): Promise<void> {
        let region =
            this.commonService.getSubRegionBaseOnPostalCode(this.params.postalCode) || '';
        this.changeRegion.emit(region)
        try{
            const latLong = await this.local.getLatLongByPostalCode(this.params.postalCode);
            this.placeMarkerAndPanTo(latLong)
        } catch(e){ console.warn(e)}
      
        // this.geocoder.geocode({

        //     address: this.params.postalCode,
        //     componentRestrictions: {
        //         country: 'SG'
        //     }
        // }, (results: any, status: any) => {
        //     if (status === 'OK') {
        //         const location = results[0].geometry.location;
        //         const latLong = { lat: location.lat(), lng: location.lng() }
        //         this.placeMarkerAndPanTo(latLong)
        //     } else {
        //         console.log('Geocode was not successful for the following reason: ' + status);
        //     }
        // });
    }

    getPostalCode(addressComponents: any[]): string {
        for (let i = 0; i < addressComponents.length; i++) {
            if (addressComponents[i].types.includes('postal_code')) {
                return addressComponents[i].long_name;
            }
        }
        return '';
    }

    geocodeLatLng(latLng: any): void {
        this.geocoder.geocode({ location: latLng }, (results: any, status: any) => {
            console.log(results, status, latLng)
            if (status === 'OK') {
                if (results[0]) {
                    const addressComponents = results[0].address_components;
                    this.address = results[0].formatted_address;
                    const postalCode = this.getPostalCode(addressComponents);

                    this.ngZone.run(() => {
                        this.params.postalCode = postalCode;
                        this.params.latLong = latLng
                    });
                } else {
                    alert('No results found');
                }
            } else {
                alert('Geocoder failed due to: ' + status);
            }
        });
    }
}